import { Row, Col, Card, Button, Skeleton, Divider } from "antd";
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import { Badge } from "antd";
import moment from "moment";
import lang from "../../helper/langHelper";
import { ArrowLeftOutlined } from "@ant-design/icons";

function View() {
  const sectionName = lang("Content");
  const routeName = "static-content";

  const params = useParams();
  const { request } = useRequest();
  const [list, setList] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchData = (slug) => {
    request({
      url: apiPath.staticContent + "/" + slug,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    setLoading(true);
    fetchData(params.slug);
  }, []);

  return (
 
     <>
      <Button
          type="default"
          className="mb-2"
          style={{ color: "black" }}
          onClick={() => window.history.back()}
        >
         Back
        </Button>
        <Card title={sectionName + ` ${lang("Detail")}`}>
          {loading ? (
            <Skeleton active />
          ) : (
            <>
              <div className="view-inner-cls">
                <h5>{lang("Status")}:</h5>
                <h6>
                  {list.isActive ? (
                    <Badge status="success" text="Active" />
                  ) : (
                    <Badge status="error" text="InActive" />
                  )}
                </h6>
              </div>

              <div className="view-inner-cls">
                <h5>{lang("Created_On")}:</h5>
                <h6>
                  {list.createdAt
                    ? moment(list.createdAt).format("DD-MMM-YYYY")
                    : "-"}
                </h6>
              </div>
              <div className="view-inner-cls view-inner-cls-uh">
                <h5>{lang("Description")}:</h5>
                <h6 className="cap">
                  {
                    <p
                      dangerouslySetInnerHTML={{
                        __html: list.description || "-",
                      }}
                    ></p>
                  }
                </h6>
              </div>
            </>
          )}
        </Card>
     </>
    
 
  );
}

export default View;
